import { Box, COLOR_PALETTE, Indicator, Text, desktopFirstMediaQuery } from '@inflearn/ds-react';
import Link from 'next/link';

type Props = {
  href: string;
  label: string;
  isActive: boolean;
  isNew?: boolean;
};

export default function UserNavigationEl({ href, isActive, label, isNew = false }: Props) {
  return (
    <Box
      component="li"
      py={8}
      px={12}
      css={{
        [desktopFirstMediaQuery.tablet]: {
          borderBottom: `2px solid ${isActive ? COLOR_PALETTE.infgreen[7] : 'transparent'}`,
        },
      }}
    >
      <Link
        href={href}
        style={{ display: 'block' }}
        aria-label={isActive ? `현재 ${label}페이지` : `${label}페이지로 이동`}
        aria-current={isActive ? 'page' : undefined}
        onClick={(e) => {
          if (isActive) {
            e.preventDefault();
          }
        }}
      >
        <Text
          component="span"
          mr={8}
          weight={700}
          color={isActive ? 'infgreen' : 'gray.5'}
          css={{
            [desktopFirstMediaQuery.tablet]: {
              display: 'none',
            },
          }}
        >
          •
        </Text>
        {isNew ? (
          <Indicator
            inline
            label="N"
            radius="xl"
            position="middle-end"
            styles={{
              common: {
                width: 19,
                height: 16,
                right: -14,
                zIndex: 1,
              },
            }}
          >
            <Text
              component="span"
              weight={isActive ? 700 : 500}
              color={isActive ? 'gray.9' : 'gray.5'}
            >
              {label}
            </Text>
          </Indicator>
        ) : (
          <Text
            component="span"
            weight={isActive ? 700 : 500}
            color={isActive ? 'gray.9' : 'gray.5'}
          >
            {label}
          </Text>
        )}
      </Link>
    </Box>
  );
}
